import { render, staticRenderFns } from "./App.vue?vue&type=template&id=ee54dcac"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=ee54dcac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../Users/afei/podcod_saas_project/shoppaas_member_front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports